import { render, staticRenderFns } from "./market-clues.pug?vue&type=template&id=66aefa42&lang=pug&"
import script from "./market-clues.ts?vue&type=script&lang=ts&"
export * from "./market-clues.ts?vue&type=script&lang=ts&"
import style0 from "./market-clues.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports